import React, {Component} from 'react';
import {RouteComponentProps} from 'react-router';
import {Button} from '@material-ui/core';
import Logo from 'components/Logo';
import './index.scss';
import RouteURLs from 'RouteURLs';
import NextRouteURLs from 'NextRouteURLs';
import {loadDiscount} from 'services/discounts';
import {Discount} from 'services/entities/discounts';
import ProgressSpinner from 'components/ProgressSpinner';
import Confetti from 'react-confetti';

interface ViewDiscountPageState {
  discount: Discount|null;
}

export default class ViewDiscountPage extends Component<RouteComponentProps<{code:string}>, ViewDiscountPageState> {
  state: ViewDiscountPageState = {
    discount: null
  };

  componentDidMount() {
    loadDiscount(this.props.match.params.code).then(
      discount => this.setState({discount: discount}),
      () => this.props.history.push(RouteURLs.NOT_FOUND)
    );
  }

  onApplyClick = () => {
    this.props.history.push(NextRouteURLs.SPACES);
  };

  onCloseClick = () => {
    this.props.history.push(NextRouteURLs.HOME);
  };

  render() {
    const discount: Discount|null = this.state.discount;

    return <div className="view-discount-page">
      <Confetti numberOfPieces={200} />
      <Logo />
      { discount && <>
        <p>We wanted to say thanks, so here's a little gift, from us, to you.</p>
        <p className="description">{ discount!.description }</p>
        <p>A discount code to use on your next booking.</p>
        <p>Apply now.</p>
        <Button className="apply" onClick={this.onApplyClick}>Use code: { discount!.code.toUpperCase() }</Button>
        <Button className="close" onClick={this.onCloseClick}>Close</Button>
      </> }
      { !discount && <ProgressSpinner /> }
    </div>;
  }
}